import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ClockIcon, ZapIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/offer';
const proofPoints = ['Sistema de 7 pasos ya armado', '9 activos incluidos hoy', 'Pago único de $27'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 pb-16 pt-10 sm:pt-14" data-id="element-60" data-mp="4jvvvb7dj8w9">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-61" data-mp="127ef5fynvtei" />
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-brand-cyan/10 blur-[120px]" aria-hidden="true" data-id="element-62" data-mp="x8b85pz4fd3w" />

      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-5" data-id="element-63" data-mp="nbyj55eitnfh">
        <Logo size="lg" data-id="element-64" data-mp="3d33fx1m3uzmc" />

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-8 max-w-3xl text-center font-display text-3xl uppercase leading-[1.08] text-white sm:text-4xl md:text-5xl" data-id="element-65" data-mp="3czfny6wb6l9q">
          Genera tu <span className="text-brand-red" data-id="element-66" data-mp="3o59a5dwsawbw">primer ingreso con AI</span> en un plan
          de 48 horas
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="mt-5 max-w-2xl text-center text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-67" data-mp="3e8wjyq0g70lw">
          El sistema completo para vender servicios de AI a negocios locales: la oferta, el
          sitio web, los anuncios, los scripts de cierre y el asistente que ejecuta por ti.
          Sin experiencia previa.
        </motion.p>

        <motion.ul initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-68" data-mp="2hincgih9yklh">
          {proofPoints.map(point => <li key={point} className="flex items-center gap-2 text-sm font-medium text-white/70" data-id="element-69" data-mp="nbl4gqm0mqd3">
              <CheckIcon className="h-4 w-4 text-brand-cyan" aria-hidden="true" data-id="element-70" data-mp="ibyrmia3nc4t" />
              {point}
            </li>)}
        </motion.ul>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-10 w-full" data-id="element-71" data-mp="deq8ofh4n42i">
          <img src={heroImage} alt="Bundle completo de 48 Hrs AI Cash Machine: cursos, plantillas y software" className="mx-auto w-full max-w-3xl rounded-2xl border border-white/10 shadow-[0_40px_80px_-40px_rgba(34,211,238,0.45)]" data-id="element-72" data-mp="162c95ev25sl5" />
        </motion.div>

        <div className="mt-10 w-full max-w-xl rounded-2xl border border-white/10 bg-ink-900/80 p-6 backdrop-blur" data-id="element-73" data-mp="3lui70k7oini7">
          <p className="text-center text-sm font-semibold uppercase tracking-[0.2em] text-white/50" data-id="element-74" data-mp="3htgaib55cpjx">
            Precio exclusivo de hoy
          </p>
          <div className="mt-4 flex items-center justify-center gap-4" data-id="element-75" data-mp="21a4ubxltom71">
            <span className="relative font-display text-4xl text-white/40 sm:text-5xl" data-id="element-76" data-mp="26a99nkazvavo">
              $1,997
              <span className="absolute left-0 top-1/2 h-[3px] w-full -translate-y-1/2 -rotate-6 bg-brand-red" aria-hidden="true" data-id="element-77" data-mp="2b196yqo0zuyp" />
            </span>
            <span className="rounded-lg bg-brand-red px-4 py-2 font-display text-4xl text-white sm:text-5xl" data-id="element-78" data-mp="2kyndnyk5d5dt">
              $27
            </span>
          </div>
          <CtaButton className="mt-6" subLabel="Pago único · Acceso inmediato" data-id="element-79" data-mp="2oye7kb4z01mk" />
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/45" data-id="element-80" data-mp="2tz1yyxx42khb">
            <span className="flex items-center gap-1.5" data-id="element-81" data-mp="uokcdjy9xl4o">
              <ZapIcon className="h-3.5 w-3.5 text-brand-cyan" aria-hidden="true" data-id="element-82" data-mp="zkrbotw5zydn" />
              Acceso en menos de 2 minutos
            </span>
            <span className="flex items-center gap-1.5" data-id="element-83" data-mp="4dgw6qh8nf60">
              <ClockIcon className="h-3.5 w-3.5 text-brand-cyan" aria-hidden="true" data-id="element-84" data-mp="3vgni4u78vzrw" />
              Garantía de devolución total
            </span>
          </div>
        </div>
      </div>
    </header>;
}